export var ThemeDefault = {
    primary: {
        50: { hex: '#8E8E8E', contrast: '#ffffff' },
        100: { hex: '#a3a3a3', contrast: '#ffffff' },
        200: { hex: '#6e6e6e', contrast: '#ffffff' },
        300: { hex: '#3d3d3d', contrast: '#ffffff' },
        400: { hex: '#666666', contrast: '#ffffff' },
        500: { hex: '#262626', contrast: '#ffffff' },
        600: { hex: '#000000', contrast: '#ffffff' },
        700: { hex: '#000000', contrast: '#ffffff' },
        800: { hex: '#000000', contrast: '#ffffff' },
        900: { hex: '#000000', contrast: '#ffffff' },
        A100: { hex: '#000000', contrast: '#ffffff' },
        A200: { hex: '#000000', contrast: '#ffffff' },
        A400: { hex: '#000000', contrast: '#ffffff' },
        A700: { hex: '#666666', contrast: '#ffffff' },
        contrastDefaultColor: 'dark'
    },
    theme: {
        50: { hex: '#fff6ea', contrast: '#000000' },
        100: { hex: '#ffe5c3', contrast: '#000000' },
        200: { hex: '#ffd59d', contrast: '#000000' },
        300: { hex: '#ffc577', contrast: '#000000' },
        400: { hex: '#ffb84b', contrast: '#000000' },
        500: { hex: '#ffa52b', contrast: '#000000' },
        600: { hex: '#de8814', contrast: '#ffffff' },
        700: { hex: '#b56902', contrast: '#ffffff' },
        800: { hex: '#a65900', contrast: '#ffffff' },
        900: { hex: '#643900', contrast: '#ffffff' },
        A100: { hex: '#FFFFFF', contrast: '#000000' },
        A200: { hex: '#FFFBF8', contrast: '#000000' },
        A400: { hex: '#FFDCC5', contrast: '#000000' },
        A700: { hex: '#FFCDAC', contrast: '#000000' },
        contrastDefaultColor: 'dark'
    }
};
